import { getCouponState,getCoupon } from '@/api/coupon';
import { isLogin, loginJump } from '@/utils/login';
import confirm from '@/v-ui/Confirm';
import $ from 'jquery';
import manager from '../manager';
import Modal from '@/v-ui/Modal';
import translate from '@/utils/translate';
import {getPlatform} from '@/utils/page'
import toast from '@/v-ui/Toast'
import { SLD } from '@/utils/INTERFACE';
import { getSystem } from '@/utils/site'
import { isApp } from '@/utils/page';

async function refreshState(dom, key) {
	try {
		var data = await getCouponState(key)
	} catch (err) {
		console.warn("优惠券状态获取错误", dom,err)
	}
	if (data.isCollected) {
		$(dom).addClass("collected")
	} else {
		$(dom).removeClass("collected")
	}
	if (data.isDisable) {
		$(dom).addClass("disable")
	} else {
		$(dom).removeClass("disable")
	}
}

manager.add('coupon.status', {
	created(ruleId) {
		if (!ruleId) return
		refreshState(this.dom, ruleId)
	}
})


function getSuccessModal(successLink){
	let modal = new Modal(`
			<img style="margin-top:20px" src="${translate("//img14.joybuy.com/uba/jfs/t1/1725/8/11595/46378/5bd00fcbE3c349709/72cd1a067e9a6833.png")}" />
			<p style="margin: 42px auto 0 auto;width:400px;font-family:Helvetica;font-weight:bold;font-size:24px;color:#222222;text-align:center;line-height:1.5;">${translate("You've already claimed this coupon!")}</p>
			<div class="button-group" style="text-align:center;margin-top:31px;">
				<button class="close flat" style="border-color:#222222;padding:0 50px;height:45px;font-family:Helvetica;font-size:20px;line-height:1.2;color:#222222;">${translate('Go back')}</button>
				<a target="_blank" href="${successLink}"><button class="confirm" style="background:#222222;border-color:#565656;padding:0 50px;height:45px;font-family:Helvetica;font-size:20px;line-height:1.2">${translate('Shop now')}</button></a>
			</div>
			`, {
				style: "width:655px;top:15%"
		})
	return modal
}


manager.add('coupon.get', {
	created(id, key) {
		if (!id) return
		if($(this.dom).hasClass("collected")||$(this.dom).hasClass("disabled")){
			return
		}
		var {platform}=getPlatform()
		$(this.dom).on("click", async () => {
			if(!isLogin()){
				loginJump()
				return
			}
			try{
				var res=await getCoupon(id,key)
			}catch(err){
				if(err.code==5){
					loginJump()
					return
				}
				if(platform=='pc'){
					confirm.warning(err.message)
				}else{
					toast(err.message)
				}
				return
			}
			if(platform=='pc'){
				if(getSystem()=='ept'){
					let successLink
					if(isApp()){
						successLink=$(this.dom).attr("success-app-link")
					}else{
						successLink=$(this.dom).attr("success-link")
					}
					if(!successLink){
						if(res.aCodeList&&res.aCodeList[0]){
							successLink=`${SLD().index.pc}/coupon?aCode=${res.aCodeList[0]}`
						}else{
							successLink=SLD().index.pc
						}
					}
					let modal=getSuccessModal(successLink)
					modal.show()
				}else{
					confirm.success(res.resultMsg)
				}
			}else{
				toast(res.resultMsg)
			}
			refreshState($(this.dom).closest('li'), id)
		})
	},
	destroyed() {
		$(this.dom).off("click")
	}
})
